// @store-module
import { Module } from "vuex";
import { profileState, initialState } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";

const profileStore: Module<any, profileState> = {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export default profileStore;
